 
 $ = jQuery;
 $(document).ready(function () {

    if($('#video_url').length > 0){
    //SDG TOOLS PAGE LOAD VIDEOS SCRIPT START
    $("#video_language").prop("selectedIndex", 1);
    $('#video_url').attr("src", $("#video_language").prop("selectedIndex", 1).val());

    $('#video_language').on('change', function () {
        $('#video_url').attr("src", $(this).val());
    });
    //SDG TOOLS PAGE LOAD VIDEOS SCRIPT END

    var userId = $("#user_id").val();
        var nodeId = $("#node_id").val();
        var iframe = $('#video_url')[0];
        var player = new Vimeo.Player(iframe);
        var playing = false;
        var simulationTime = 0;

        window.setInterval(function() {
            if (playing) {
            simulationTime++;
            }
        }, 1000);

        videotracker = {
            user_id: userId,
            node_id: nodeId,
            percent: 0,
            seconds :0,
            duration: 0
        };
        player.on('play', function(data) {
            playing = true;
        });
        
        player.on('pause', function(data) {
            getProgress(data);
        });

        player.on('ended', function(data) {
            getProgress(data);
        });
        
        player.on('timeupdate', function(data) {
            //console.log(data);
            var currentPercent = Math.ceil(data.percent * 100); 
            //sconsole.log(currentPercent);
        });

        player.on('seeked', function(data){
            if (data.seconds > simulationTime) { 
                // player.api('seekTo', Math.floor(simulationTime));
                player.setCurrentTime(simulationTime);
            }
            else {
                simulationTime = data.seconds;
            }  
            simulationTime = data.seconds;
        });
    }
});

function getProgress(data){
    playing = false;
    var currentPercent = Math.ceil(data.percent * 100); 
    videotracker['percent'] = currentPercent;
    videotracker['seconds'] = data.seconds;
    videotracker['duration'] = data.duration;
    console.log(videotracker);
    saveProgress(videotracker);
}

function saveProgress(videotracker){
    var pathname = window.location.host;
    console.log(pathname);
    var url = '';
    if (pathname == "115.113.146.196") {
    url = '/habitat';
    }

    $.ajax({
        url: url + "/saveProgress",
        type: 'POST',
        data: videotracker,
        success: function (data) {
            
        }
    });
}